import { render, staticRenderFns } from "./Linha.vue?vue&type=template&id=3b9ad63c&"
import script from "./Linha.vue?vue&type=script&lang=js&"
export * from "./Linha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports